export default __webpack_public_path__ + "static/media/T560_T564_L_BD.5adbf29a.pdf";